<ion-header mode="md">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-icon color="favorite" slot="icon-only" name="notifications-circle-outline"></ion-icon>
    </ion-buttons>
    <ion-title color="favorite">{{ title() }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Close">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="notification-html-content" [innerHTML]="sanitizedHtml"></div>
</ion-content>

<ion-footer>
  <ion-toolbar mode="md">
    <ion-button expand="block" (click)="dismiss()">Close</ion-button>
  </ion-toolbar>
</ion-footer>

